var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcSend24 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.298 4.676c-1.031-.49-2.126.546-1.693 1.603l1.38 3.37c.138.335.415.595.76.71l5.083 1.707-5.083 1.706a1.25 1.25 0 0 0-.76.71l-1.38 3.37c-.433 1.058.662 2.094 1.693 1.604l13.181-6.261c.952-.452.952-1.806 0-2.258z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSend24);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };